import { useEffect, useState } from 'react'
import { db, FirebaseDocRefType } from 'firebase/index'
import { dateToString } from 'lib/helper'

const useQueryStockAmountByBreadRef = (breadRef: FirebaseDocRefType): number => {
  const [stockAmount, setStockAmount] = useState<number>(0)
  useEffect(() => {
    if (!breadRef) return
    db.collectionGroup('store_stocks')
      .where('bread_ref', '==', breadRef)
      .where('type', '==', 'preorder')
      .orderBy('date', 'asc')
      .startAt(dateToString(new Date()))
      .get()
      .then((snapshots) => {
        setStockAmount(snapshots.docs.length)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [breadRef])
  return stockAmount
}

export default useQueryStockAmountByBreadRef
